export const LANG_LIST = [
    {
        label: "Australia(English)",
        value: "en_au",
    },
    {
        label: "Canada(English)",
        value: "en_ca",
    },
    // {
    //   label: "Deutschland(Deutsch)",
    //   value: "de_de",
    //   isForeign: true,
    // },
    {
        label: "Deutschland(English)",
        value: "en_de",
    },
    {
        label: "España(Español)",
        value: "es_es",
    },
    // {
    //   label: "Italia(Italiano)",
    //   value: "it_it",
    //   isForeign: true,
    // },
    {
        label: "Singapore(English)",
        value: "en_sg",
    },
    {
        label: "United Kingdom(English)",
        value: "en_gb",
    },
    {
        label: "United States(English)",
        value: "en_us",
    },
    {
        label: "中国(简体中文)",
        value: "zh_cn",
    },
    {
        label: "台湾(中国)(繁體中文)",
        value: "zh_tw",
    },
]

export const languageValueToRealLangMap: Record<string, string> = {
    en_au: "en_GB",
    en_ca: "en_US",
    de_de: "de_DE",
    en_de: "en_GB",
    es_es: "es",
    it_it: "it_IT",
    en_sg: "en_GB",
    en_gb: "en_GB",
    en_us: "en_US",
    zh_cn: "zh_CN",
    zh_tw: "zh_HK"
};


export const chromeLanguageMap: Record<string, string> = {
    "en-AU": "en_au",
    "en-CA": "en_ca",
    "en-US": "en_us",
    "it-IT": "it_it",
    "es-ES": "es_es",
    "zh-CN": "zh_cn",
    "zh-TW": "zh_tw",
    "zh": "zh_cn",
    "es": "es_es",
    "en-GB": "en_gb",
    "en-GB-oxendict": "en_gb",
    "it": "it_it"
}

